import { breakpoints, colors, fonts, pxToCssFont, pxToRem } from '@vfit/shared/themes';
import styled from 'styled-components';

export const Card = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media screen and (min-width: ${breakpoints.desktop}) {
    display: grid;
    justify-content: center;
    justify-items: center;
    gap: ${pxToRem(15)};
    padding: ${pxToRem(0, 40)};
    min-width: ${pxToRem(296)};
  }
  p {
    margin: 0;
  }
`;

export const CardContent = styled.div`
  display: flex;
  flex-direction: column;

  @media screen and (min-width: ${breakpoints.desktop}) {
    gap: ${pxToRem(20)};
    align-items: center;
  }
`;

export const CardText = styled.p`
  font-family: ${fonts.exbold};
  font-weight: 400;
  color: ${colors.$262626};
  margin-top: 6px;
  margin-bottom: 0;
  min-height: 40px;
  ${pxToCssFont(24, 30)}

  @media (min-width: ${breakpoints.desktop}) {
    ${pxToCssFont(36, 50)}
  }
`;

export const CardDescription = styled.div`
  font-family: ${fonts.regular};
  font-weight: 400;
  color: ${colors.$262626};
  min-height: 40px;
  ${pxToCssFont(18, 24)}
  margin-top: 0;
  margin-bottom: 0;

  p {
    margin-top: 0;
    margin-bottom: 0;
  }

  @media (min-width: ${breakpoints.desktop}) {
    margin: 0 auto;
    margin-top: 17px;
    max-width: ${pxToRem(200)};
    min-height: 40px;
    text-align: center;
  }
`;

